
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      deliveryRadius: "",
      deliveryCharge: "",
      id: ""
    };
  },
  async mounted() {
    this.getSavedConfiguration();
  },
  computed: {
    ...mapGetters("restaurant", ["getChannelId"])
  },
  methods: {
    ...mapActions("restaurant", ["getDeliveryConfiguration"]),
    handleChargesSubmission() {
      this.$emit("complete", {
        deliveryRadius: this.deliveryRadius,
        deliveryCharge: this.deliveryCharge,
        id: this.id
      });
      this.$emit("show-onboarding-complete-dialog");
    },
    async getSavedConfiguration() {
      try {
        const response = await this.getDeliveryConfiguration(
          this.getChannelId("whatsapp")
        );
        if (response && response.data) {
          const deliveryConfig = response.data;
          this.deliveryRadius = deliveryConfig.delivery_radius;
          this.id = deliveryConfig.id;
          this.deliveryCharge = deliveryConfig.delivery_charge;
        }
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
    }
  }
};
